<p-breadcrumb [model]="items">
  <ng-template let-item pTemplate="item">
    <a
      [routerLink]="item.routerLink"
      [ngClass]="isLast(item) ? 'unclickable-item' : 'clickable-item' ">
      {{ item.label | htmlToText }}
    </a>
  </ng-template>
</p-breadcrumb>
